import { Microfrontend } from '@thoughtspot/microfrontends';
import { loadMicroFrontendComponent } from './microfrontend-wrapper';
import { initMicroFrontend } from './microfrontends.util';

enum NavigationComponents {
    NavigationHub = 'NavigationHub',
    QuickLinkContainer = 'QuickLinkContainer',
}

export const NavigationHub = loadMicroFrontendComponent(
    Microfrontend.NAVIGATION,
    NavigationComponents.NavigationHub,
);

export const QuickLinkContainer = loadMicroFrontendComponent(
    Microfrontend.NAVIGATION,
    NavigationComponents.QuickLinkContainer,
);

initMicroFrontend(Microfrontend.NAVIGATION);
